import React from 'react';
import './App.css'; // You can keep the default App.css for global styling
// import Slider from './Slider'; // Import the Slider component
import PRWIP from './PRWIP'; // Import the Slider component
import Slider1 from './SliderRow1'; // Import the Slider component
import Slider2 from './SliderRow2'; // Import the Slider component
import Slider3 from './SliderRow3'; // Import the Slider component
import Slider4 from './SliderRow4'; // Import the Slider component
import Slider5 from './SliderRow5'; // Import the Slider component
import Slider6 from './SliderRow6'; // Import the Slider component
import Slider7 from './SliderRow7'; // Import the Slider component
import Slider8 from './SliderRow8'; // Import the Slider component
import Slider9 from './SliderRow9'; // Import the Slider component
import Slider10 from './SliderRow10'; // Import the Slider component


function App() {
  return (
    <div className="App">
      <h2>Web3 Legal Engineering Press Release</h2>
      <PRWIP />
      <br/>
      <hr/>
      <br/>
      <Slider1 />
      <br/>
      <hr/>
      <hr/>
      <br/>


    </div>
  );
}

export default App;
